import { NumberInput } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { useEffect, useState } from 'react';

import { NumberRangeFilter } from '../../data-access/types/filters';

import { useColFilter } from '@data-access';

type NumberRangeFilterProps = {
  filter: NumberRangeFilter;
  name: string;
};

export const NumberRangeFilterComponent = ({
  filter,
  name,
}: NumberRangeFilterProps) => {
  const [filterValue, setFilter] = useColFilter('orders', name);
  const [range, setRange] = useState(
    (filterValue as [number | null, number | null]) || [null, null],
  );

  const handleMinMaxChange = useDebouncedCallback(
    (min: number | null, max: number | null) => {
      setFilter([min, max]);
    },
    300,
  );

  const handleMinChange = (value: string | number) => {
    setRange([value === '' ? null : Number(value), range[1]]);
    handleMinMaxChange(value === '' ? null : Number(value), range[1]);
  };

  const handleMaxChange = (value: string | number) => {
    setRange([range[0], value === '' ? null : Number(value)]);
    handleMinMaxChange(range[0], value === '' ? null : Number(value));
  };

  useEffect(() => {
    // when filterValue is reset from outside, reset the local value too
    if (!filterValue) {
      setRange([null, null]);
    }
  }, [filterValue]);

  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <NumberInput
        label={filter.label}
        max={filter.range?.[1] ?? undefined}
        min={filter.range?.[0] ?? undefined}
        onChange={handleMinChange}
        placeholder="Min"
        value={range[0] === null ? '' : range[0]}
      />
      <NumberInput
        label=" "
        max={filter.range?.[1] ?? undefined}
        min={filter.range?.[0] ?? undefined}
        onChange={handleMaxChange}
        placeholder="Max"
        value={range[1] === null ? '' : range[1]}
      />
    </div>
  );
};
